import { useMutation } from '@hooks/reactQuery';

import { getNetworkElementsCheckPath } from '@api/networkElements';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IError, IResponseError } from '@interfaces/errors/apiErrors';
import { INetworkElementsSFTPPathsDTO } from '@interfaces/networkElements/dto/networkElements';

import { EErrorCodes } from '@enums/errorCodes';

import { NETWORK_ELEMENTS_CHECK_PATH } from '@constants/queryKeys';

interface IUseMutateNetworkElementsCheckPathReturned {
	handleCheckPath: (dto: INetworkElementsSFTPPathsDTO) => void;
	isLoadingCheckPath: boolean;
	errorConnectedEnabledMessage: string | undefined;
}

const useMutateNetworkElementsCheckPath = (): IUseMutateNetworkElementsCheckPathReturned => {
	const {
		mutateAsync,
		isLoading,
		error: mutationError,
	} = useMutation<INetworkElementsSFTPPathsDTO>({
		mutationKey: [NETWORK_ELEMENTS_CHECK_PATH],
		mutationFn: getNetworkElementsCheckPath,
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => (
				item.code === EErrorCodes.networkElementNotConnected ||
				item.code === EErrorCodes.networkElementNotEnabled ||
				item.code === EErrorCodes.pathDuIsNotValid ||
				item.code === EErrorCodes.pathCuIsNotValid
			))) {
				handleErrorFromMessage(err);
			}
		},
	});

	const errorConnectedEnabledMessage = mutationError ? mutationError?.errors?.find((item: IError) => (
		item.code === EErrorCodes.networkElementNotConnected ||
		item.code === EErrorCodes.networkElementNotEnabled
	))?.message : undefined;

	return {
		handleCheckPath: mutateAsync,
		errorConnectedEnabledMessage,
		isLoadingCheckPath: isLoading,
	};
};

export default useMutateNetworkElementsCheckPath;
